<template>
    <Layout
        :header="{ text: '要保人變更', backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">
        <div class="pt-2 pb-6">
            <Process :steps="['選擇保單', '填寫資料', '確認資料', '視訊預約',]" :index="1"></Process>
        </div>
        <h2 class="font-bold text-2xl pb-4">填寫新要保人資料</h2>
        <p class="pb-8">新要保人如非本公司有效保單之要保人，後續將郵寄 CRS/FATCA 相關文件，請新要保人填寫後回郵至本公司</p>
        <h3 class="text-xl font-bold pb-3">要保人基本資料</h3>
        <div class="mb-8">
            <!-- 資料與他人重複提示燈箱 -->
            <PopupCheckBDP v-model:postApiCheckBDP="postApiCheckBDP" @confirm="storeInfo" @close="closeIsLoading" />
            <CaseBox>
                <ul class="list">
                    <li>
                        <h5 class="list__item__title">{{ userData.applicant.field.name }}</h5>
                        <input type="text" v-model.trim="userData.applicant.data.name" inputmode="text"
                            autocomplete="off" maxlength="20" :placeholder="userData.applicant.field.name">
                        <div class="error-msg">
                            {{ userData.applicant.errors?.name }}
                        </div>
                    </li>
                    <li v-if="userData.foreignCurrency">
                        <h5 class="list__item__title">{{ userData.applicant.field.engName }}</h5>
                        <input type="text" v-model.trim="userData.applicant.data.engName" inputmode="text"
                            autocomplete="off" maxlength="62" :placeholder="userData.applicant.field.engName">
                        <div class="error-msg">
                            {{ userData.applicant.errors?.engName }}
                        </div>
                    </li>
                    <li>
                        <h5 class="list__item__title">{{ userData.applicant.field.id }}</h5>
                        <input type="text" v-model.trim="userData.applicant.data.id" inputmode="text" autocomplete="off"
                            maxlength="10" :placeholder="userData.applicant.field.id">
                        <div class="error-msg">
                            {{ userData.applicant.errors?.id }}
                        </div>
                    </li>
                    <li>
                        <h5 class="list__item__title">{{ userData.applicant.field.country }}</h5>
                        <input type="text" v-model.trim="userData.applicant.data.country" inputmode="text"
                            autocomplete="off" maxlength="50" :placeholder="userData.applicant.field.country"
                            :disabled="true">
                    </li>
                    <li>
                        <h5 class="list__item__title">{{ userData.applicant.field.birthday }}</h5>
                        <DatePicker v-model:visiblePopup="pageData.visiblePopup"
                            v-model:userDate="userData.applicant.data.birthday" :minDateGap="110" />
                        <button class="input-base input-calendar" @click="pageData.visiblePopup = true"
                            v-text="formatToTwDate(userData.applicant.data.birthday)" />
                        <div class="error-msg">
                            {{ userData.applicant.errors?.birthday }}
                        </div>
                    </li>
                    <li>
                        <h5 class="list__item__title">{{ userData.applicant.field.relation }}</h5>
                        <Multiselect v-model="userData.applicant.data.relation" class="select-base"
                            :placeholder="userData.applicant.field.relation" track-by="text" label="label"
                            :options="userData.relationList" :can-clear="false" :can-deselect="false" />
                        <div class="error-msg">
                            {{ userData.applicant.errors?.relation }}
                        </div>
                    </li>
                </ul>
            </CaseBox>
        </div>
        <h3 class="text-xl font-bold pb-3">要保人職業內容</h3>
        <div class="mb-8">
            <CaseBox>
                <ul class="list">
                    <li>
                        <h5 class="list__item__title">{{ userData.profession.field.unit }}</h5>
                        <input type="text" v-model.trim="userData.profession.data.unit" inputmode="text"
                            autocomplete="off" maxlength="50" :placeholder="userData.profession.field.unit">
                        <div class="error-msg">
                            {{ userData.profession.errors?.unit }}
                        </div>
                    </li>
                    <li>
                        <h5 class="list__item__title">{{ userData.profession.field.nature }}</h5>
                        <Multiselect v-model="userData.profession.data.nature" class="select-base"
                            :placeholder="userData.profession.field.nature" track-by="text" label="label"
                            :options="userData.businessDataList" :can-clear="false" :can-deselect="false" />
                        <div class="error-msg">
                            {{ userData.profession.errors?.nature }}
                        </div>
                    </li>
                    <li>
                        <h5 class="list__item__title">{{ userData.profession.field.position }}</h5>
                        <input type="text" v-model.trim="userData.profession.data.position" inputmode="text"
                            autocomplete="off" maxlength="50" :placeholder="userData.profession.field.position">
                        <div class="error-msg">
                            {{ userData.profession.errors?.position }}
                        </div>
                    </li>
                    <li>
                        <h5 class="list__item__title">{{ userData.profession.field.code }}</h5>
                        <Multiselect v-model="userData.profession.data.code" class="select-base"
                            :placeholder="userData.profession.field.code" track-by="text" label="label"
                            :options="userData.professionSubList" :can-clear="false" :can-deselect="false" />
                        <div class="error-msg">
                            {{ userData.profession.errors?.code }}
                        </div>

                    </li>
                    <li>
                        <h5 class="list__item__title">{{ userData.profession.field.content }}</h5>
                        <input type="text" v-model.trim="userData.profession.data.content" inputmode="text"
                            autocomplete="off" maxlength="50" :placeholder="userData.profession.field.content">
                        <div class="error-msg">
                            {{ userData.profession.errors?.content }}
                        </div>
                    </li>
                </ul>
                <button class="w-full mt-2 py-2 text-center text-[#0093C1]"
                    @click="(e) => { partTimeFormVisible = !partTimeFormVisible; }">
                    <div v-if="partTimeFormVisible" class="inline-block align-text-bottom">
                        <svg fill="currentColor" style="width: 18px; height: 18px;" lns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24">
                            <title>minus-circle</title>
                            <path
                                d="M17,13H7V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                        </svg>
                    </div>
                    <div v-else class="inline-block align-text-bottom">
                        <svg fill="currentColor" style="width: 18px; height: 18px;" lns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24">
                            <title>plus-circle</title>
                            <path
                                d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                        </svg>
                    </div>
                    {{ partTimeFormVisible ? '移除兼職內容' : '新增兼職內容' }}
                </button>
                <template v-if="partTimeFormVisible">
                    <ul class="list">
                        <li>
                            <h5 class="list__item__title">{{ userData.profession.field.partTimeCode }}</h5>
                            <Multiselect v-model="userData.profession.data.partTimeCode" class="select-base"
                                :placeholder="userData.profession.field.partTimeCode" track-by="text" label="label"
                                :options="userData.professionList" :can-clear="false" :can-deselect="false" />
                            <div class="error-msg">
                                {{ userData.profession.errors?.partTimeCode }}
                            </div>
                        </li>
                        <li>
                            <h5 class="list__item__title">{{ userData.profession.field.partTimeContent }}</h5>
                            <input type="text" v-model.trim="userData.profession.data.partTimeContent" inputmode="text"
                                autocomplete="off" maxlength="50" :placeholder="userData.profession.field.content">
                            <div class="error-msg">
                                {{ userData.profession.errors?.partTimeContent }}
                            </div>
                        </li>
                    </ul>
                </template>
            </CaseBox>
        </div>
        <h3 class="text-xl font-bold pb-3">要保人聯絡資訊</h3>
        <div class="mb-8">
            <CaseBox>
                <ul class="list">
                    <li>
                        <h5 class="list__item__title">收費地址</h5>
                        <p class="text-sm pb-2">地址不可為郵政信箱</p>
                        <div class="flex pb-2">
                            <div class="w-1/2 pr-1">
                                <Multiselect v-model="userData.connectionInfo.data.chargeInfo.city" class="select-base"
                                    :options="userData.cityInfo.cityList" placeholder="請選擇" :can-clear="true"
                                    :can-deselect="false"
                                    @select="setCityValue(userData.connectionInfo.data.chargeInfo)"
                                    @clear="() => clearAddress('chargeInfo')" />
                            </div>
                            <div class="w-1/2 pl-1">
                                <Multiselect v-model="userData.connectionInfo.data.chargeInfo.cityArea"
                                    class="select-base" track-by="showText" label="showText" valueProp="showText"
                                    :options="userData.cityInfo.countyList[userData.connectionInfo.data.chargeInfo.city]"
                                    placeholder="請選擇" :disabled="!userData.connectionInfo.data.chargeInfo.city"
                                    :can-clear="false" :searchable="false" :can-deselect="false"
                                    @select="setCityArea(userData.connectionInfo.data.chargeInfo)" />
                            </div>
                        </div>
                        <input type="text" v-model.trim="userData.connectionInfo.data.chargeInfo.address"
                            :disabled="!userData.connectionInfo.data.chargeInfo.cityArea" inputmode="text"
                            autocomplete="off" maxlength="62" placeholder="地址">
                        <div class="error-msg">
                            {{ userData.connectionInfo.errors?.chargeInfo?.address }}
                        </div>
                    </li>
                    <li>
                        <h5 class="list__item__title">市話</h5>
                        <div class="flex">
                            <div class="w-1/3 pr-1">
                                <input v-model.trim="userData.connectionInfo.data.chargeInfo.telAreaCode"
                                    inputmode="numeric" autocomplete="off" type="text"
                                    :placeholder="userData.connectionInfo.field.chargeInfo.telAreaCode" maxlength="4"
                                    @input="clearTel(userData.connectionInfo.data.chargeInfo)">
                            </div>
                            <div class="w-2/3 pl-1">
                                <input v-model.trim="userData.connectionInfo.data.chargeInfo.tel" inputmode="numeric"
                                    autocomplete="off" type="text" placeholder="電話" maxlength="8"
                                    :disabled="!userData.connectionInfo.data.chargeInfo.telAreaCode">
                            </div>
                        </div>
                        <div class="mt-1">
                            <input v-model.trim="userData.connectionInfo.data.chargeInfo.telExt" inputmode="numeric"
                                autocomplete="off" type="text" placeholder="分機" maxlength="6"
                                :disabled="!userData.connectionInfo.data.chargeInfo.telAreaCode">
                        </div>
                        <div class="error-msg">
                            {{ userData.connectionInfo.errors?.chargeInfo?.tel }}
                        </div>
                    </li>
                </ul>
                <hr class="my-6">
                <div class="text-right pb-4">
                    <input class="pr-3 align-top" type="checkbox" v-model="sameAddress" /> 同收費地址
                </div>
                <ul class="list">
                    <li>
                        <h5 class="list__item__title">住所 (戶籍地址)</h5>
                        <p class="text-sm pb-2">地址不可為郵政信箱</p>
                        <div class="flex pb-2">
                            <div class="w-1/2 pr-1">
                                <Multiselect v-model="userData.connectionInfo.data.applicantInfo.city"
                                    class="select-base" :options="userData.cityInfo.cityList" placeholder="請選擇"
                                    :can-clear="true" :can-deselect="false"
                                    @select="setCityValue(userData.connectionInfo.data.applicantInfo)"
                                    @clear="() => clearAddress('applicantInfo')" :disabled="sameAddress" />
                            </div>
                            <div class="w-1/2 pl-1">
                                <Multiselect v-model="userData.connectionInfo.data.applicantInfo.cityArea"
                                    class="select-base" track-by="showText" label="showText" valueProp="showText"
                                    :options="userData.cityInfo.countyList[userData.connectionInfo.data.applicantInfo.city]"
                                    placeholder="請選擇"
                                    :disabled="sameAddress || !userData.connectionInfo.data.applicantInfo.city"
                                    :can-clear="false" :searchable="false" :can-deselect="false"
                                    @select="setCityArea(userData.connectionInfo.data.applicantInfo)" />
                            </div>
                        </div>
                        <input v-model.trim="userData.connectionInfo.data.applicantInfo.address"
                            :disabled="sameAddress || !userData.connectionInfo.data.applicantInfo.cityArea"
                            inputmode="text" autocomplete="off" type="text" maxlength="62" placeholder="地址">
                        <div class="error-msg">
                            {{ userData.connectionInfo.errors?.applicantInfo?.address }}
                        </div>
                    </li>
                    <li>
                        <h5 class="list__item__title">市話</h5>
                        <div class="flex">
                            <div class="w-1/3 pr-1">
                                <input type="text" v-model.trim="userData.connectionInfo.data.applicantInfo.telAreaCode"
                                    inputmode="numeric" autocomplete="off"
                                    :placeholder="userData.connectionInfo.field.applicantInfo.telAreaCode" maxlength="4"
                                    :disabled="sameAddress"
                                    @input="clearTel(userData.connectionInfo.data.applicantInfo)">
                            </div>
                            <div class="w-2/3 pl-1">
                                <input type="text" v-model.trim="userData.connectionInfo.data.applicantInfo.tel"
                                    inputmode="numeric" autocomplete="off" placeholder="電話" maxlength="8"
                                    :disabled="sameAddress || !userData.connectionInfo.data.applicantInfo.telAreaCode">
                            </div>
                        </div>
                        <div class="mt-1">
                            <input v-model.trim="userData.connectionInfo.data.applicantInfo.telExt" inputmode="numeric"
                                autocomplete="off" type="text" placeholder="分機" maxlength="6"
                                :disabled="sameAddress || !userData.connectionInfo.data.applicantInfo.telAreaCode">
                        </div>
                        <div class="error-msg">
                            {{ userData.connectionInfo.errors?.applicantInfo?.tel }}
                        </div>
                    </li>
                </ul>
                <hr class="my-6">
                <p class="text-[#C10013] text-sm pb-2">本次輸入之要保人行動電話、E-mail 將同時更新以您為要保人於本公司投保之所有個人險有效及停效保單</p>
                <ul class="list">
                    <li>
                        <h5 class="list__item__title">行動電話</h5>
                        <div class="flex">
                            <div class="w-1/2 pr-1">
                                <Multiselect v-model="userData.connectionInfo.data.mobileCountry" placeholder="國碼"
                                    track-by="text" :options="userData.mobileCodeList" :can-clear="false"
                                    class="select-base" :can-deselect="false"
                                    @select="validateMobile2(userData.connectionInfo.data, userData.connectionInfo.errors)" />
                            </div>
                            <div class="w-1/2 pl-1">
                                <input v-model.trim="userData.connectionInfo.data.mobile" inputmode="numeric"
                                    autocomplete="off" maxlength="11" type="text"
                                    :placeholder="userData.connectionInfo.field.mobile"
                                    :disabled="!userData.connectionInfo.data.mobileCountry">
                                <div class="error-msg">
                                    {{ userData.connectionInfo.errors?.mobile }}
                                </div>
                            </div>
                        </div>
                    </li>
                    <li>
                        <h5 class="list__item__title">E-mail (非必填)</h5>
                        <input v-model.trim="userData.connectionInfo.data.email" maxlength="264" inputmode="email"
                            autocomplete="off" type="text" placeholder="電子信箱">
                        <div class="error-msg">
                            {{ userData.connectionInfo.errors?.email }}
                        </div>
                    </li>
                </ul>
            </CaseBox>
        </div>
        <ul class="text-sm text-[#86878F] list-disc pl-6">
            <li>新要保人須無條件承受變更前本保單之權利義務，並請確認是否須一併變更要保人住所、收費地址、E-mail、電話、行動電話。</li>
            <li>要保人變更屬保單價值贈與，提醒原要保人、應依「遺產及贈與稅法」第24條規定將超過全年贈與稅免稅額之部分，於贈與三十日內向國稅局申報，以免受罰。</li>
        </ul>
        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="false" @click="onSubmit">下一步</button>
        </template>
        <Loading :is-loading="pageData.isLoading > 0" />
        <InfoBox v-if="errorBoxVisble" :closeHandel="closeBox" :title="errorBoxTitle">
            <div v-html="errorMessage" />
        </InfoBox>
        <InfoBox v-show="infoBoxVisble" :closeHandel="() => { infoBoxVisble = false; }" title="變更後將取消豁免附約"
            type="confirm" :cancelHandel="cancelHandelInfoBox" :okHandel="() => submit(true)"
            :buttonText="{ no: '取消本次變更', yes: '同意取消豁免附約' }">
            要保人變更，將會需要一併取消保單的豁免附約，請確認是否繼續變更要保人。
        </InfoBox>
    </Layout>
</template>

<script setup>
import Layout from '@/components/cloudCounter/Layout.vue'
import Process from '@/components/cloudCounter/Process.vue'
import CaseBox from '@/components/cloudCounter/CaseBox.vue'
import InfoBox from '@/components/cloudCounter/InfoBox.vue'

import { ref, computed, reactive, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import Loading from '@/components/Loading.vue';
import { postSubmit } from '@/apis/applicantChange';
import Multiselect from '@vueform/multiselect';
import router from '@/router';
import routeName from '@/router/constant';
import { clearTel, getData, getErrors, setCityArea, setCityValue, validateAddress, validateApplicantData, validateEmail, validateForm, validateMobile, validateProfessionData, validateTel, getProfessionSubData } from '@/views/cloudECounter/applicantChange/applicantChangeService';
import applicantChangeField from '@/views/cloudECounter/applicantChange/applicantChangeField';
import DatePicker from '@/components/dialogs/DatePicker.vue';
import { formatToTwDate } from '@/utils/is/dateUtils';
import PopupCheckBDP from '@/components/dialogs/PopupCheckBDP.vue';


const route = useRoute();
const store = useStore();
const code = route.meta.code;
const pageData = reactive({
    isLoading: 0,
    visiblePopup: false,
});
const userData = reactive({
    applicant: {
        data: {
            name: '',
            engName: '',
            id: '',
            country: '中華民國',
            birthday: '',
            relation: '',
        },
        field: {
            ...applicantChangeField.applicantDataInfo,
        },
        errors: {
            name: '',
            engName: '',
            id: '',
            country: '',
            birthday: '',
            relation: '',
        },
    },
    profession: {
        data: {
            unit: '',
            nature: '',
            position: '',
            content: '',
            code: '',
            partTimeCode: '',
            partTimeContent: '',
        },
        field: {
            ...applicantChangeField.profession,
        },
        errors: {
            unit: '',
            nature: '',
            position: '',
            content: '',
            code: '',
            partTimeCode: '',
            partTimeContent: '',
        },
    },
    connectionInfo: {
        data: {
            applicantInfo: {
                city: '',
                cityArea: '',
                address: '',
                telAreaCode: '',
                tel: '',
                telExt: '',
                zipcode: '',
            },
            chargeInfo: {
                city: '',
                cityArea: '',
                address: '',
                telAreaCode: '',
                tel: '',
                telExt: '',
                zipcode: '',
            },
            mobileCountry: '',
            mobile: '',
            email: '',
        },
        field: {
            ...applicantChangeField.connectionInfo,
        },
        errors: {
            applicantInfo: {
                city: '',
                cityArea: '',
                address: '',
                telAreaCode: '',
                tel: '',
                telExt: '',
            },
            chargeInfo: {
                city: '',
                cityArea: '',
                address: '',
                telAreaCode: '',
                tel: '',
                telExt: '',
            },
            mobileCountry: '',
            mobile: '',
            email: '',
        },

    },
    foreignCurrency: false,
    relationList: [],
    professionList: [],
    mobileCodeList: [],
    cityInfo: {
        countyList: [],
        cityList: [],
    },
    exemptRiderList: [],
    businessDataList: [],
    professionSubList: [],
});
const partTimeFormVisible = ref(false);
const sameAddress = ref(false);
const errorBoxVisble = ref(false);
const errorMessage = ref('');
const errorBoxTitle = ref('');
const errorType = ref('');
const infoBoxVisble = ref(false);
const postApiCheckBDP = ref(false);


const result = computed(() => {
    return store.state.services.changeItemsResult[code];
});

const initData = () => {
    if (result.value) {
        Object.assign(userData, { ...result.value });
        if (result.value.profession.data.partTimeCode) {
            partTimeFormVisible.value = true;
        }
        pageData.isLoading = 0;
    } else {
        getData(pageData, userData);
    }
    // validateForm(userData);

    // 將值回填後清空，避免回到選擇保單頁後有殘留資料
    store.dispatch('services/setChangeItemsResult', {
        code: code,
        value: null,
    });
}
initData();

const messageArray = computed(() => {
    const array = [];
    array.push(
        ...getErrors(userData.applicant.errors),
        ...getErrors(userData.profession.errors),
        ...getErrors(userData.connectionInfo.errors),
    );
    return array;
});

// const isPass = computed(() => {
//      return messageArray.value.length === 0;
// })

const onSubmit = () => {
    errorMessage.value = '';
    validateForm({ ...userData, partTimeFormVisible: partTimeFormVisible.value });
    if (messageArray.value.length > 0) {
        errorBoxTitle.value = '系統提示'
        errorMessage.value = messageArray.value.join('<br>');
        errorBoxVisble.value = true;
        return;
    }
    store.dispatch('services/setChangeItemsResult', {
        code: code,
        value: userData,
    });

    if (userData.exemptRiderList && userData.exemptRiderList.length > 0) {
        // const message = userData.exemptRiderList.map(p => {
        //     return `【${p.name}(${p.item})】`;
        // }).join('、');
        // showExemptRider(`辦理要保人變更，需一併取消${message}，謝謝！`, () => {
        //     submit(true);
        // });
        infoBoxVisble.value = true;
    } else {
        submit(false);
    }
};
const submit = (agreeCancelExemptRider) => {
    pageData.isLoading = 1;

    let chargeArea = userData.connectionInfo?.data?.chargeInfo?.cityArea?.split(' ')[1] || '';
    let chargeZipcode = userData.connectionInfo?.data?.chargeInfo?.cityArea?.split(' ')[0] || '';
    let applicantInfoArea = userData.connectionInfo?.data?.applicantInfo?.cityArea?.split(' ')[1] || '';
    let applicantInfoZipcode = userData.connectionInfo?.data?.applicantInfo?.cityArea?.split(' ')[0] || '';

    const request = {
        applicantInfo: userData.applicant.data,
        profession: userData.profession.data,
        //charge: userData.connectionInfo.data.chargeInfo,
        charge: { ...userData.connectionInfo.data.chargeInfo, city: userData.connectionInfo.data.chargeInfo.city || '', cityArea: chargeArea, zipcode: chargeZipcode },
        //applicant: userData.connectionInfo.data.applicantInfo,
        applicant: { ...userData.connectionInfo.data.applicantInfo, city: userData.connectionInfo.data.applicantInfo.city || '', cityArea: applicantInfoArea, zipcode: applicantInfoZipcode },
        mobileCountry: userData.connectionInfo.data.mobileCountry,
        mobile: userData.connectionInfo.data.mobile,
        email: userData.connectionInfo.data.email,
        agreeCancelExemptRider: agreeCancelExemptRider,
    };

    postSubmit(request).then(res => {
        checkInfo();
        // store.dispatch('services/setChangeItemsResult', {
        //    code: code,
        //    value: userData,
        // });
        // router.push({ name: routeName.CLOUD_E_COUNTER_CONFIRM });
    }).catch(ex => {
        errorBoxTitle.value = '系統錯誤';
        errorMessage.value = ex?.data?.errorMessage;
        if (ex?.data?.errorCode === 'InitTransaction.Check') {
            errorBoxTitle.value = '您目前無法線上辦理申請';
            errorMessage.value = ex?.data?.errorMessage;
            errorType.value = 'STOP_PROCESS';
        }
        errorBoxVisble.value = true;
    }).finally(() => {
        pageData.isLoading = 0;
    });
};

const checkInfo = () => {
    pageData.isLoading = 1;
    postApiCheckBDP.value = true;
};
const storeInfo = () => {
    store.dispatch('services/setChangeItemsResult', {
        code: code,
        value: userData,
    });
    router.push({ name: routeName.CLOUD_E_COUNTER_CONFIRM });
};
/** 資料重複燈箱關閉 */
const closeIsLoading = () => {
    pageData.isLoading = 0;
};

const closeBox = () => {
    if (errorType.value === 'STOP_PROCESS') {
        router.push({ name: routeName.CLOUD_E_COUNTER_HOME });
    }
    errorBoxVisble.value = false
}

const cancelHandelInfoBox = () => {
    errorType.value = 'STOP_PROCESS';
    closeBox();
}

const validateMobile2 = (data, errors) => {
    if (data.mobileCountry !== '886') {
        errorBoxTitle.value = '系統提示'
        errorMessage.value = '您的行動電話為國外電話，考量作業時效，本次無法使用雲端e櫃檯服務功能，請輸入台灣的行動電話、通知您的服務人員協助辦理，或洽詢免付費服務電 0809-000-550，造成您的不便，敬祈見諒！';
        errorBoxVisble.value = true;
        data.mobileCountry = '';
        data.mobile = '';
    }
    // validateMobile(data, errors);
}

const clearAddress = (type) => {
    if (type === 'chargeInfo') {
        userData.connectionInfo.data.chargeInfo.cityArea = '';
        userData.connectionInfo.data.chargeInfo.address = '';
    } else {
        userData.connectionInfo.data.applicantInfo.cityArea = '';
        userData.connectionInfo.data.applicantInfo.address = '';
    }
}


watch(() => userData.applicant.data.birthday, (nV) => {
    // validateApplicantData(userData);
    if (nV) {
        userData.applicant.errors.birthday = '';
    }
}, { immediate: false });

watch(() => userData.profession.data.nature, (nV) => {
    if (nV) {
        userData.profession.data.code = ''
        getProfessionSubData({ "nature": nV }, userData, pageData);
        // validateProfessionData(userData);
    }
});

watch(sameAddress, (nV) => {
    if (nV) {
        userData.connectionInfo.data.applicantInfo.city = userData.connectionInfo.data.chargeInfo.city
        userData.connectionInfo.data.applicantInfo.cityArea = userData.connectionInfo.data.chargeInfo.cityArea
        userData.connectionInfo.data.applicantInfo.address = userData.connectionInfo.data.chargeInfo.address
        userData.connectionInfo.data.applicantInfo.telAreaCode = userData.connectionInfo.data.chargeInfo.telAreaCode
        userData.connectionInfo.data.applicantInfo.tel = userData.connectionInfo.data.chargeInfo.tel
        userData.connectionInfo.data.applicantInfo.telExt = userData.connectionInfo.data.chargeInfo.telExt
    }
})

watch(partTimeFormVisible, (nV) => {
    if (!nV) {
        userData.profession.data.partTimeCode = '';
        userData.profession.data.partTimeContent = '';
    }
})

</script>

<style lang="scss" scoped></style>
